import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'core/services/breadcrumb.service';
import { Crumb } from 'core/models';
import { UiService } from 'core/services';

@Component({
  selector: 'lms-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() crumbs: Crumb[] | any[]; // crumbs are calculated automatically, only use this to avoid this
  @Input() label: string; // label for current breadcrumb element (the last one)
  section: any;
  items: Crumb[] | any[];

  constructor(public uiService: UiService, private breadcrumbService: BreadcrumbService, private router: Router) {}

  ngOnInit(): void {
    const crumbs = this.crumbs ? this.crumbs : this.breadcrumbService.setCrumbs(this.router.url, this.label);
    this.setCrumbs(crumbs);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.label) {
      this.setCrumbs(this.breadcrumbService.setCrumbs(this.router.url, this.label));
    }
  }

  setCrumbs(crumbs: any): void {
    this.crumbs = crumbs;
    if (this.crumbs && this.crumbs.length) {
      this.items = this.crumbs.slice(1);
      this.section = this.crumbs[0];
    }
  }
}
